import React from "react";
import { Row, Col } from "antd";

import InputText from "../../../shared/components/inputs/text/InputText";
import Avatar from "../../../shared/components/avatar/Avatar";

const inputs = {
  name: {
    name: "name",
    placeholder: "Nome",
    rules: [{ required: true, message: "Nome é obrigatório!" }]
  },
  password: {
    name: "password",
    placeholder: "Senha",
    rules: [{ required: true, message: "Senha é obrigatório!" }]
  },
  email: {
    name: "email",
    placeholder: "E-mail",
    rules: [
      {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
        message: "Por favor insira um e-mail válido"
      }
    ]
  },
  phone: {
    name: "phone",
    placeholder: "Celular",
    rules: [{ required: true, message: "Telefone é obrigatório!" }]
  },
  cpf: {
    name: "cpf",
    placeholder: "CPF",
    rules: [{ required: true, message: "CPF é obrigatório!" }]
  },
  rg: {
    name: "rg",
    placeholder: "RG",
    rules: [{ required: true, message: "RG é obrigatório!" }]
  },
  address: {
    name: "address",
    placeholder: "Endereço",
    rules: [{ required: true, message: "Endereço é obrigatório!" }]
  }
};

class DadosPessoais extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: ""
    };
    this.places = React.createRef();
  }

  componentDidMount = () => this.props.form.validateFields();

  clearState = () =>
    this.setState({ imageUrl: "" });

  onFinishUpload = image => {
    this.setState({ imageUrl: image });
  }

  render() {
    const { form, user } = this.props;
    return (
      <React.Fragment>
        <Row>
          <h2>Informações Pessoais</h2>
        </Row>
        <Row gutter={14}>
          <Col span={6}>
            <Avatar
              onFinishUpload={this.onFinishUpload}
              imageUrl={
                this.state.imageUrl ? this.state.imageUrl : user.photoUrl
              }
              form={form}
              name="photo"
            />
          </Col>
          <Col span={18}>
            <Row>
              <Col flex={1}>
                <InputText
                  initialValue={user.name}
                  form={form}
                  name={inputs.name.name}
                  placeholder={inputs.name.placeholder}
                  rules={inputs.name.rules}
                />
              </Col>
            </Row>
            <Row>
              <Col flex={1}>
                <InputText
                  initialValue={user.email}
                  form={form}
                  name={inputs.email.name}
                  placeholder={inputs.email.placeholder}
                  rules={inputs.email.rules}
                />
              </Col>
            </Row>
            <Row gutter={14}>
              <Col span={12}>
                <InputText
                  type={"password"}
                  autoComplete={'new-password'}
                  initialValue={user.password}
                  form={form}
                  name={inputs.password.name}
                  placeholder={inputs.password.placeholder}
                  rules={user.id ? [] : inputs.password.rules}
                />
              </Col>
              <Col span={12}>
                <InputText
                  initialValue={user.phone}
                  form={form}
                  name={inputs.phone.name}
                  mask="(##) #####-####"
                  placeholder={inputs.phone.placeholder}
                  rules={inputs.phone.rules}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default DadosPessoais;
